<template>
  <div :bordered='false'>
    <div class='table-page-search-wrapper'>
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='24'>
          <!-- <a-col :md='8' :sm='12'>
            <a-form-item :label="$t(I18N_KEY + 'selectDate')">
              <a-date-picker
                v-model="queryParam.endDate"
                picker="month"
                format="YYYY-MM"
                :allow-clear="true"
              />
            </a-form-item>
          </a-col> -->
          <a-col :md='6' :sm='8'>
                  <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
                    <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('search') }}</a-button>
<!--                    <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>{{ $t('reset')-->
<!--                      }}</a-button>-->
                      <a-button type='primary' @click="downLoadData()" icon='download'
                              style='margin-left: 8px'>{{ $t('exportFile')
                      }}</a-button>
                  </span>
          </a-col>
        </a-row>
      </a-form>

      <a-table
        ref='table'
        rowKey='id'
        size='middle'
        :columns='columns'
        :dataSource='dataSource'
        :pagination='false'
        :loading='loading'
        bordered
        @change='handleTableChange'>
      </a-table>
      <div style='margin-top: 15px; text-align: right;'>
        <v-pagination
          v-if='total'
          :page-num='form.pageNum'
          :page-size='form.pageSize'
          :total='total'
          @change='handleTableChange' />
      </div>
  </div>
  </div>
</template>

<script>
import { DatePicker } from 'ant-design-vue'
import { filterObj } from '@/utils/util'
import { getOrderAmountSituation, getLoanAccount } from '@/webpublicapi/order'
import Dict from '../modules/Dict'
import PendingModal from '../order/modules/PendingModal'
import vModal from '../modules/Modal'
import OrderDetail from '../order/OrderDetail'
import moment from 'moment'
import exportFile from '@/api/exportFile'

const I18N_KEY = 'order.'

export default {
  name: 'PendingOrderlist',
  components: {
    'a-date-picker': DatePicker,
    vModal,
    OrderDetail,
    Dict,
    PendingModal
  },
  data() {
    return {
      I18N_KEY,
      toggleSearchStatus: false,
      visible: false,
      orderId: undefined,
      custInfoId: undefined,
      form: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      dataSource: [],
      // 查询条件
      queryParam: {
        // 'selectDate': [moment().startOf('day'), moment().startOf('day')]
        // 'endDate': moment()
      },
      loading: false,
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t(I18N_KEY + 'year'),
          align: 'left',
          dataIndex: 'year'
        },
        {
          title: this.$t(I18N_KEY + 'month'),
          align: 'left',
          dataIndex: 'month'
        },
        {
          title: this.$t(I18N_KEY + 'loanPersonCount'),
          align: 'left',
          dataIndex: 'loanPersonCount'
        },
        {
          title: this.$t(I18N_KEY + 'loanCount'),
          align: 'left',
          dataIndex: 'loanCount'
        },
        {
          title: this.$t(I18N_KEY + 'loanAmount'),
          align: 'left',
          dataIndex: 'loanAmount'
        },

        {
          title: this.$t(I18N_KEY + 'repayPersonCount'),
          align: 'left',
          dataIndex: 'repayPersonCount'
        },
        {
          title: this.$t(I18N_KEY + 'repayCount'),
          align: 'left',
          dataIndex: 'repayCount'
        },

        {
          title: this.$t(I18N_KEY + 'repayAmount'),
          align: 'left',
          dataIndex: 'repayAmount'
        },

        {
          title: this.$t(I18N_KEY + 'repayPrincipal'),
          align: 'left',
          dataIndex: 'repayPrincipal'
        },

        {
          title: this.$t(I18N_KEY + 'repayInterest'),
          align: 'left',
          dataIndex: 'repayInterest'
        },

        {
          title: this.$t(I18N_KEY + 'overduePersonCount'),
          align: 'left',
          dataIndex: 'overduePersonCount'
        },

        {
          title: this.$t(I18N_KEY + 'overdueCount'),
          align: 'left',
          dataIndex: 'overdueCount'
        },

        {
          title: this.$t(I18N_KEY + 'overdueAmount'),
          align: 'left',
          dataIndex: 'overdueAmount'
        },

        {
          title: this.$t(I18N_KEY + 'onOrderPersonCount'),
          align: 'left',
          dataIndex: 'onOrderPersonCount'
        },

        {
          title: this.$t(I18N_KEY + 'onOrderCount'),
          align: 'left',
          dataIndex: 'onOrderCount'
        },

        {
          title: this.$t(I18N_KEY + 'onOrderAmount'),
          align: 'left',
          dataIndex: 'onOrderAmount'
        }

      ]
    }
  },
  created() {
    this.loadData(1)
  },
  methods: {
    downLoadData() {
      var params = this.getQueryParams()// 查询条件
      console.log('下载参数',params)
      const file = {
        fileUrl: '/api/web/webpublic/orderContract/orderAmountSituationExcel',
        fileName:   "OrderAmountSituation.xlsx",
      }
      this.loading = true;
      exportFile(file).catch(e => {
        this.$message.error(e.message);
      }).finally(() => {
        this.loading = false;
      })
    },
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus
    },
    searchQuery() {
      // this.loadData(1)
      this.loadData()
    },
    transformStringToLow(str) {
      return str && str.toLocaleLowerCase()
    },
    // loadData(arg) {
    //   // 加载数据 若传入参数1则加载第一页的内容
    //   if (arg === 1) {
    //     this.form.pageNum = 1
    //   }
    //   this.loading = true
    //   var params = this.getQueryParams()// 查询条件
    //   params.type = 0
    //   getOrderContractContract(params).then((res) => {
    //     if (res.code === 1000) {
    //       this.total = res.data.total
    //       this.dataSource = res.data.list
    //     } else {
    //       this.total = 0
    //       this.dataSource = []
    //       this.$message.error(res.msg)
    //     }
    //     this.loading = false
    //   }).catch(e => {
    //     this.loading = false
    //     this.$message.error(e.message)
    //   })
    // },
    loadData() {
      // if (!this.queryParam.endDate) {
      //   this.$message.error('请选择月份')
      //   return
      // }
      this.loading = true
      var params = this.getQueryParams()
      getOrderAmountSituation(params).then((res) => {
        if (res.code === 1000) {
          this.total = res.data.total
          this.dataSource = res.data.list
        } else {
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    getQueryParams() {
      // var selectDate  = this.queryParam.selectDate
      // console.log("params"+selectDate)
      var param = Object.assign({}, this.queryParam)
      param.pageNum = this.form.pageNum
      param.pageSize = this.form.pageSize
      // param.endDate = moment(this.queryParam.endDate).endOf('month').format('YYYY-MM-DD')
      // param.pageNum = this.form.pageNum
      // param.pageSize = this.form.pageSize
      // param.startDate =  selectDate && this.transformTime(selectDate[0])
      // param.endDate = selectDate && this.transformTime(selectDate[1])
      return filterObj(param)
    },
    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.loadData()
    },
    // 重置字典类型搜索框的内容
    searchReset() {
      var that = this
      that.queryParam.selectDate = ''
      that.queryParam.startDate = ''
      that.queryParam.endDate = ''
    },
    changeModal(visible) {
      this.visible = visible
    },
    handleDetail(row) {
      this.orderId = row.id
      this.custInfoId = row.custInfoId
      this.changeModal(true)
    }
  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";
</style>
